import { render, staticRenderFns } from "./ServiceMessages.vue?vue&type=template&id=7c03628a"
import script from "./ServiceMessages.vue?vue&type=script&lang=js"
export * from "./ServiceMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports